import Lenis from 'lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const lenis = new Lenis();

export default class ScrollHandler {
	init() {
		lenis.on('scroll', ScrollTrigger.update);
		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});
		gsap.ticker.lagSmoothing(0);
	}
}

export class ScrollAnchors {
	init() {
		document.querySelectorAll('a[href^="#"]').forEach((link) => {
			link.addEventListener('click', (e) => {
				const target = document.querySelector(link.getAttribute('href'));
				if (!target) return;
				e.preventDefault();
				lenis.scrollTo(target, { offset: -100 });
			});
		});
	}
}